import { ref } from 'vue'
import { listNewsletters } from '@/api/newsletters'
import type { Newsletter, NewsletterStatus } from '@/types/newsletter'
import type { PaginationMeta } from '@/types/finance'

export function useNewsletters(organisationId: number) {
  const newsletters = ref<Newsletter[]>([])
  const loading = ref<boolean>(false)
  const error = ref<string | null>(null)
  const meta = ref<PaginationMeta | null>(null)

  async function fetch(status?: NewsletterStatus | 'all', page = 1): Promise<void> {
    loading.value = true
    error.value = null
    try {
      const params: { status?: string; page?: number } = { page }
      if (status && status !== 'all') params.status = status
      const result = await listNewsletters(organisationId, params)
      newsletters.value = result.data
      meta.value = result.meta
    } catch {
      error.value = 'Failed to load newsletters.'
    } finally {
      loading.value = false
    }
  }

  return { newsletters, loading, error, meta, fetch }
}
